import { createContext } from "react"

import { useCustomRegions, useRecentRegions } from "@/components/TopNavigation/components/RegionSelector/services"
import { RegionGroup } from "@/components/TopNavigation/components/RegionSelector/types"

type ContextValue = {
    customRegions: ReturnType<typeof useCustomRegions>
    recentRegions: ReturnType<typeof useRecentRegions>
    regionGroups: RegionGroup[]
    selectedRegionValue: string
    setSelectedRegionValue: React.Dispatch<React.SetStateAction<string>>
    toggleIsOpen: () => void
}

export const RegionSelectorContext = createContext<ContextValue>({} as ContextValue)
